import { useEffect } from "react";
import usePixelateCanvas from "./usePixelateCanvas";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { PIXELATED_LEVEL } from "../../utils/constants";

const MIN_LEVEL_PIXELATION = PIXELATED_LEVEL[0]
const MAX_LEVEL_PIXELATION = PIXELATED_LEVEL[PIXELATED_LEVEL.length - 1]

export default function PixelatedImage(props) {
    const { src, pixelSize, className } = props;
    
    const initialPixelSize = useSelector(state => {
        const currentQuestion = state.game.questions[state.game.currentIndex]
        return currentQuestion.revealImage ? MAX_LEVEL_PIXELATION : MIN_LEVEL_PIXELATION
    });

    const { canvasRef, discoverPixelated } = usePixelateCanvas({
        pixelSize: initialPixelSize,
        image: src
    });

    useEffect(() => {
        discoverPixelated({
            pixelSize
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pixelSize]);

    return (
        <canvas className={className} ref={canvasRef} />
    );
}

PixelatedImage.propTypes = {
    src: PropTypes.string,
    pixelSize: PropTypes.number,
    className: PropTypes.string
};